"use client";

import { IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function PasswordVisibilityToggle({ visible, onToggle }) {
  return (
    <IconButton
      size="small"
      onClick={onToggle}
      edge="end"
      aria-label={visible ? "Hide password" : "Show password"}
    >
      {visible ? (
        <VisibilityOff sx={{ fontSize: 19 }} />
      ) : (
        <Visibility sx={{ fontSize: 19 }} />
      )}
    </IconButton>
  );
}
